import { AlertFilterIsFilterParser } from './parsers/is';
import { AlertFilterExistsFilterParser } from './parsers/exists';
import { AlertFilterIsOneOfFilterParser } from './parsers/is-one-of';
import { AlertFilterLookupFilterParser } from './parsers/lookup';
import { AlertFilterIsBetweenFilterParser } from './parsers/is-between';
class AlertFilterModelManipulator {
    alertFilterToElasticFilterParsers;
    constructor() {
        this.alertFilterToElasticFilterParsers = [
            new AlertFilterIsFilterParser(),
            new AlertFilterIsBetweenFilterParser(),
            new AlertFilterExistsFilterParser(),
            new AlertFilterIsOneOfFilterParser(),
            new AlertFilterLookupFilterParser(),
        ];
    }
    convertElasticToFilter(elasticFilter, negate = false) {
        return (this.alertFilterToElasticFilterParsers
            .map(parser => parser.getFilter(elasticFilter, negate))
            // First non-null filter
            .find(filter => Boolean(filter)) ?? undefined);
    }
    convertToElastic(filter) {
        return (this.alertFilterToElasticFilterParsers
            .map(parser => parser.getElasticFilter(filter))
            .find(
        // Return the first non-null filter
        filter => Boolean(filter)) ?? undefined);
    }
    getHumanReadableValue(filter) {
        return String(filter.getFilterValueFormat());
    }
}
export const alertFilterModelManipulator = new AlertFilterModelManipulator();
//# sourceMappingURL=model.manipulator.js.map